export const TiposCliente = [
    {
        id: "EA",
        nombre: "Empresa/Empleador"
    },
    {
        id: "VI",
        nombre: "Independiente Voluntario"
    },
    {
        id: "PS",
        nombre: "Contratante No Afiliado"
    },
    {
        id: "DE",
        nombre: "Empresa/Empleador"
    },
    {
        id: "OI",
        nombre: "Independiente Prest. Servicios" 
    }
];

export const obtenerTipoCliente = (id: string) =>
    TiposCliente.find( tc => tc.id === id );


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/modelo/TiposCliente.ts